import classNames from "classnames";
import InputFieldSet from "PFComponents/text/input_field_set";
import { profileHash } from "PFCore/helpers/profile_hash";
import useForceUpdate from "PFCore/helpers/use_force_update";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./overwrites.module.scss";
import ResetButton from "./reset_button";

const Names = ({ exportableProfile, isBlindModeOn }) => {
  const { t } = useTranslation();
  const forceUpdate = useForceUpdate();
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    setHasChanged(exportableProfile.hasChangedNames());
  }, [exportableProfile.hasChangedNames()]);

  return (
    <div className={css.flexRow}>
      <InputFieldSet
        controlledValue
        label={t("export.edit.firstName")}
        value={
          isBlindModeOn
            ? `${t("export.profiles.candidate")} ${profileHash(exportableProfile.profile.id)}`
            : exportableProfile.firstName || ""
        }
        handleChange={(val) => {
          exportableProfile.setFirstName(val);
          setHasChanged(val);
        }}
        disabled={isBlindModeOn}
        style={{ width: "48%" }}
      />

      <InputFieldSet
        style={{ marginLeft: 10, width: "48%" }}
        controlledValue
        label={t("export.edit.lastName")}
        value={isBlindModeOn ? "" : exportableProfile.lastName || ""}
        handleChange={(val) => {
          exportableProfile.setLastName(val);
          setHasChanged(val);
        }}
        disabled={isBlindModeOn}
      />

      <div className={classNames(css.resetLabel, { [css.isDisabled]: isBlindModeOn })}>
        {hasChanged && (
          <ResetButton
            onClick={() => {
              exportableProfile.resetNames();
              setHasChanged(false);
              forceUpdate();
            }}
          />
        )}
      </div>
    </div>
  );
};

Names.propTypes = {
  exportableProfile: PropTypes.object,
  isBlindModeOn: PropTypes.bool
};

export default Names;
